<template>
  <div class="tab-thumbnail-switcher-wrapper">
    <div
      class="tab-thumbnail-switcher-tablet-left-image"
      :style="getMediaStyle(sectionSettings.tabletImage, '1000x')"
    />
    <div class="tab-thumbnail-switcher-image-container">
      <img
        height="443"
        width="443"
        :src="resizeImageSrc(0, '443x443')"
        :srcset="`${resizeImageSrc(mediaIndex, '443x443')} 1x, 
                  ${resizeImageSrc(mediaIndex, '886x886')} 2x`"
        loading="eager"
        :alt="getMediaAlt(mediaIndex) ? getMediaAlt(mediaIndex) : product.title"
      />
    </div>
    <div
      class="tab-thumbnail-switcher-tablet-right-image"
      :style="getMediaStyle(sectionSettings.tabletImage, '1000x')"
    />

    <div
      v-if="sectionSettings.showSwitcher"
      class="tab-thumbnail-switcher-media"
    >
      <div
        v-for="(media, index) in product.media"
        :key="index"
        class="tab-thumbnail-switcher-media-image lazyload"
        :style="getMediaStyle(media.src, '154x154')"
        :class="{ active: index == mediaIndex }"
        @click="setMediaIndex(index)"
      />
    </div>
  </div>
</template>

<script>
import * as ShopifyImage from '@shopify/theme-images';

export default {
  props: {
    product: {
      type: Object
    },
    sectionSettings: {
      type: Object
    }
  },
  data() {
    return {
      mediaIndex: 0
    };
  },
  methods: {
    resizeImageSrc(index, size) {
      if (!this.getMedia(index)) {
        return false;
      }

      return ShopifyImage.getSizedImageUrl(this.getMedia(index).src, size);
    },
    getMedia(index) {
      if (this.product.media.length < 2) {
        return this.product.media[0];
      }

      return this.product.media[index];
    },
    getMediaStyle(src, size) {
      if (!src) {
        return false;
      }
      let url = ShopifyImage.getSizedImageUrl(src, size);

      return `background-image: url(${url})`;
    },
    getMediaAlt(index) {
      const mediaItem = this.product.media[index];
      if (!mediaItem) {
        return false;
      }

      return this.product.media[index].alt;
    },
    setMediaIndex(index) {
      this.mediaIndex = index;
    }
  }
};
</script>
